import { createBrowserRouter, Navigate } from "react-router-dom";

import { solicitudesRoutes } from "@features/Solicitudes";
import { solicitudesV2Routes } from "@features/Solicitudes/routes/solicitudesV2";
import { solicitudRoutes } from "@features/Solicitud/routes/solicitud";
import { solicitudV2Routes } from "@features/Solicitud/routes/solicitudV2";
import { loginRoutes } from "@features/Autenticacion/routes/login";
import { adminRoutes } from "@features/Administracion/routes/admin";
import { dashboardsRoutes } from "@features/Dashboards/routes/dashboards";
import { reporteriaRoutes } from "@features/Reporteria/routes/reporteria";

const router = createBrowserRouter([
    dashboardsRoutes,
    solicitudesRoutes,
    solicitudesV2Routes,
    solicitudRoutes,
    solicitudV2Routes,
    adminRoutes,
    reporteriaRoutes,
    loginRoutes,
    {
        path: "*",
        element: <Navigate to="/" replace />,
    },
]);

export default router;
